/* eslint-disable react/jsx-props-no-spreading */
import cx from 'classnames';

import Tooltip from '../Tooltip';
import type { TooltipProps } from '../Tooltip';

import Badge from './Badge';
import type { BadgeProps } from './Badge';

export type TooltipBadgeProps = Omit<TooltipProps, 'children'> & BadgeProps;

/**
 * A Badge wrapped in a Tooltip component.
 */
const TooltipBadge = ({
  children,
  tooltip,
  placement = 'top',
  showTooltip,
  id,
  fullWidth,
  ...badgeProps
}: TooltipBadgeProps) =>
  <Tooltip
    id={id}
    tooltip={tooltip}
    placement={placement}
    showTooltip={showTooltip}
  >
    {/* Tooltip requires its child to be inline-block  */}
    <div className={cx('inline-block', { 'width-full': fullWidth })}>
      <Badge
        fullWidth={fullWidth}
        {...badgeProps}
      >
        {children}
      </Badge>
    </div>
  </Tooltip>;

export default TooltipBadge;
